import { Component } from '@angular/core';

@Component({
  selector: 'app-revision-to-adopted-usan-instructions',
  templateUrl: './revision-to-adopted-usan-instructions.component.html',
  styleUrls: ['./revision-to-adopted-usan-instructions.component.css']
})
export class RevisionToAdoptedUsanInstructionsComponent {

}
